// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
const MONEY_FORMAT = "${{amount}}";
const formatMoney = (cents, format) => {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || MONEY_FORMAT);
  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number/100.0).toFixed(precision);
    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  value = formatWithDelimiters(cents, 2);
  return formatString.replace(placeholderRegex, value);
};

const ThemeFunc = function() {
  window.dataLayer = window.dataLayer || [];

  // Returns the element specified by the target as a param.

  const getEl = (target, is_all = false, _parent) => {
    let parent = _parent || document;
    if(is_all) {
      return parent.querySelectorAll(target);
    }
    return parent.querySelector(target);
  }

  // Returns a boolean whether the current device is mobile or not.

  const isMobile = () => {
		if (window.matchMedia('(any-hover: none)').matches || document.documentElement.clientWidth < 700) {
			return true;
		}
		return false;
	};

  // Global variable.

  const globalSelector = {
    header: '.section-header'
  }

  const sectionHeader = getEl(globalSelector.header);
  const windowHeight = window.innerHeight;

  // Returns top spacing to make sticky content to be vertically centered.

  const getStickyTop = (elem, h1 = 0, h2 = 0) => {
    var headerHeight = sectionHeader.offsetHeight;
    var elemHeight = elem.offsetHeight;
    return (windowHeight - headerHeight - elemHeight - h1) / 2 + headerHeight + h2;
  }

  // Initialize stikcy horizontal slider.

  const initStickyHorizontalSlider = () => {
    let selector = {
      section: '.section-sticky-horizontal-slider',
      container: '.section-sticky-horizontal-slider .container',
      stickyAtcBar: '.sticky-add-to-cart',
      slider: '[data-auto-scroll-carousel]',
      content: '.content-wrapper',
      sliderDot: '.swiper-pagination .swiper-pagination-bullet',
      imageWrapper: '.image-wrapper',
      stickyWrapper: '.content-sticky'
    }

    if(!isMobile()) {
      getEl(selector.section, true).forEach((section) => {

        var step = 800;
        var posY = section.getBoundingClientRect().y;

        var el__slider = getEl(selector.slider, false, section),
            el__content = getEl(selector.content, false, section),
            el__imageWrapper = getEl(selector.imageWrapper, false, section),
            el__stickyWrapper = getEl(selector.stickyWrapper, false, section);

        var sectionHeight = section.offsetHeight;
        var sliderCount = parseInt(el__slider.getAttribute('data-count'));

        if(section.classList.contains('scroll-initialized')) {
          if(posY < 0) {
            var index = parseInt(Math.abs(posY) / step) + 1;
            if (index > sliderCount) {
              index = sliderCount;
            }
            getEl(`${selector.sliderDot}:nth-child(${index})`, false, section).click();
          }
        }
        else {
          el__content.style.height = `${sectionHeight + step * sliderCount}px`;
          section.classList.add('scroll-initialized');

          // var stickyAtcBarHeight = getEl(selector.stickyAtcBar).offsetHeight;
          var stickyAtcBarHeight = 73;
          var imageStickyTop = getStickyTop(el__imageWrapper, stickyAtcBarHeight, 60);
          var contentStickyTop = getStickyTop(el__stickyWrapper, stickyAtcBarHeight);

          el__imageWrapper.style.top = `${imageStickyTop}px`;
          el__stickyWrapper.style.top = `${contentStickyTop}px`;
        }
      })

    }

  }

  // Initialize timeline scroll.

  const initTimeline = () => {
    let selector = {
      section: '.section-timeline',
      block: '.timelineBlock',
      content: '.timeline__content',
      hiddenBlock: '.timelineBlock.state--hidden',
      collapsedBlock: '.timelineBlock[data-expanded="false"]',
      expandedBlock: '.timelineBlock[data-expanded="true"]',
      line: '.line',
      imageWrapper: '.main .image-wrapper',
      expand: '.expand',
      collapse: '.collapse',
      stickyAtcBar: '.sticky-add-to-cart'
    }

    getEl(selector.section, true).forEach((section) => {
      // if(section.classList.contains('scroll-initialized')) {
      //   getEl(selector.hiddenBlock, true).forEach((block) => {
      //     if(block.getAttribute('data-expanded') == 'false') {
      //       return;
      //     }
      //     var posY = block.getBoundingClientRect().y;
      //     var el__line = getEl(selector.line, false, block);
      //     var el__content = getEl(selector.content, false, block);
      //     if(posY < windowHeight / 2) {
      //       block.classList.add('state--visible');
      //     }
      //     else {
      //       block.classList.remove('state--visible');
      //     }

      //     var lineHeight = windowHeight / 2 - posY;
      //     var contentHeight = el__content.offsetHeight;
      //     if(lineHeight > contentHeight + 15) {
      //       lineHeight = contentHeight + 15;
      //     }
      //     el__line.style.height = `${lineHeight}px`;

      //   })
      // }
      // else {
      //   section.classList.add('scroll-initialized');

      //   var el__imageWrapper = getEl(selector.imageWrapper, false, section);
      //   // var stickyAtcBarHeight = getEl(selector.stickyAtcBar).offsetHeight;
      //   var stickyAtcBarHeight = 73;
      //   var imageStickyTop = getStickyTop(el__imageWrapper, stickyAtcBarHeight, 60);
      //   el__imageWrapper.style.top = `${imageStickyTop}px`;
      // }
      getEl(selector.expand, false, section)?.addEventListener('click', (e) => {
        getEl(selector.collapsedBlock, true, section).forEach((block) => {
          block.setAttribute('data-expanded', 'true');
          e.target.setAttribute('hidden', 'true');
          getEl(selector.collapse, false, section).removeAttribute('hidden');
          // ThemeFunc.initTimeline();
        })
      })
      getEl(selector.collapse, false, section)?.addEventListener('click', (e) => {
        getEl(selector.expandedBlock, true, section).forEach((block) => {
          block.setAttribute('data-expanded', 'false');
          e.target.setAttribute('hidden', 'true');
          getEl(selector.expand, false, section).removeAttribute('hidden');
          // ThemeFunc.initTimeline();
        })
      })
    })
  }

  // Initialize testimonial func.

  const initTestimonial = () => {
    let selector = {
      section: '.section-testimonials',
      item: '.testimonial-item',
      fulldesc: '.testimonial--desc.full-desc',
      shortdesc: '.testimonial--desc.short-desc',
      readmore: '.testimonial-read-more',
      readless: '.testimonial-read-less'
    }
    getEl(selector.item, true).forEach((item) => {
      var el__shortdesc = getEl(selector.shortdesc, false, item);
      var el__fulldesc = getEl(selector.fulldesc, false, item);
      var el__readmore = getEl(selector.readmore, false, item);
      var el__readless = getEl(selector.readless, false, item);
      if(el__readmore) {
        el__readmore.addEventListener('click', () => {
          el__shortdesc.classList.add('hidden');
          el__readmore.classList.add('hidden');
          el__fulldesc.classList.remove('hidden');
          el__readless.classList.remove('hidden');
        })
      }
      if(el__readless) {
        el__readless.addEventListener('click', () => {
          el__shortdesc.classList.remove('hidden');
          el__readmore.classList.remove('hidden');
          el__fulldesc.classList.add('hidden');
          el__readless.classList.add('hidden');
        })
      }
    })
  }

  // Initialized ingredients slider.

  const ingredientsSlider = () => {
    let selector = {
      section: '.section-ingredients',
      ingredientItem: '.ingredient-grid-item',
      slider: '.ingredients-slider',
      sliderBg: '.ingredients-slider-bg',
      close: '.slider-close'
    }

    getEl(selector.section, true).forEach((section) => {
      let el__slider = getEl(selector.slider, false, section);
      getEl(selector.ingredientItem, true, section).forEach((item) => {
        item.addEventListener('click', () => {
          el__slider.classList.add('visible');
          document.body.classList.add('popup-visible');
          let index = parseInt(item.getAttribute('data-index'));
          el__slider.querySelector(`.swiper-pagination .swiper-pagination-bullet:nth-child(${index})`).click();
        })
      })
      getEl(selector.close, true, section).forEach((closeBtn) => {
        closeBtn.addEventListener('click', () => {
          el__slider.classList.remove('visible');
          setTimeout(() => {
            document.body.classList.remove('popup-visible');
          }, 300);
        })
      })
      if(getEl(selector.sliderBg, false, section)) {
        getEl(selector.sliderBg, false, section).addEventListener('click', () => {
          el__slider.classList.remove('visible');
          setTimeout(() => {
            document.body.classList.remove('popup-visible');
          }, 300);
        })
      }
    })

  }

  // Initialized NAD+ section.

  initNAD = () => {
    let selector = {
      section: '.section-nad',
      main: '.main',
      stickyCnt: '.main-wrapper',
      grid: '.nad-grid',
      gridItem: '.nad-grid-item',
      activeItem: '.nad-grid-item.active'
    }
    getEl(selector.section, true).forEach((section) => {
      var step = 800;
      var posY = section.getBoundingClientRect().y;

      var el__main = getEl(selector.main, false, section),
          el__stickyCnt = getEl(selector.stickyCnt, false, section),
          el__nadgrid = getEl(selector.grid, false, section);

      var count = parseInt(el__nadgrid.getAttribute('data-count'));

      if(section.classList.contains('scroll-initialized')) {
        if(isMobile()) {
        }
        else {
          if(posY < 0) {
            var index = parseInt(Math.abs(posY) / step) + 1;
            if (index > count) {
              index = count;
            }
            getEl(selector.activeItem, false, section).classList.remove('active');
            getEl(`${selector.gridItem}[data-index="${index}"]`, false, section).classList.add('active');
          }
        }
      }
      else {
        section.classList.add('scroll-initialized');

        if(!isMobile()) {
          var stickyAtcBarHeight = 73;
          var stickyTop = getStickyTop(el__stickyCnt, stickyAtcBarHeight);
          var height = el__main.offsetHeight + count * step;

          el__main.style.height = `${height}px`;
          el__stickyCnt.style.top = `${stickyTop}px`;
        }
      }
    })
  }

  // Recharge info

  const initRechargeInfoToggle = () => {
    document.addEventListener('click', (e) => {
      let selector = {
        trigger: '.rc_popup_label_wrapper',
        popup: '.rc_popup__block'
      }
      let eTarget = e.target;
      if(eTarget.closest(selector.trigger)) {
        getEl(selector.popup).classList.add('visible');
      }
      else {
        getEl(selector.popup)?.classList.remove('visible');
      }
    })
  }

  // Recharge frequency

  const initRechargeFrequency = () => {

    const targetNode = document.querySelector(".rc-widget-injection-parent");

    let is_opt_selected = false;

    if(targetNode) {
      const config = { attributes: true, childList: true, subtree: true };
      const rc_default_opt = targetNode.dataset.defaultOption;

      const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
          // if (mutation.type === "childList") {
          //   console.log("A child node has been added or removed.");
          // } else if (mutation.type === "attributes") {
          //   console.log(`The ${mutation.attributeName} attribute was modified.`);
          // }
          if(mutation.target.classList.contains('rc-selling-plans__dropdown')) {

            let container = document.querySelector('.rc_widget__option__plans');
            let select = mutation.target;
            let freq_opts = '';

            if(container.classList.contains('injected')) {
              return
            }
            else {
              container.classList.add('injected');
            }

            if(select.querySelectorAll('option').length <= 1) {
              container.classList.add('hide');
              return;
            }

            let idx = 0;
            let opt_arr = [];
            for(opt of select.querySelectorAll('option')) {
              let freq_val = opt.dataset.planOption.replace('Delivery every ', '').replace(' Days', '').replace(' Weeks', '');
              freq_opts += `<span class="${idx == 0 ? 'active' : ''}" data-freq="${freq_val}" data-value="${opt.getAttribute('value')}">${opt.dataset.planOption.replace('Delivery every ', '')}</span>`;
              idx ++;
              opt_arr.push(parseInt(freq_val));
            }

            opt_arr.sort((a, b) => {
              return a - b;
            })

            let freq_dom = `<div class="freq_opts_wrapper">
                <label>Delivery every:</label>
                <div class="freq_opts">${freq_opts}</div>
              </div>`;
            container.insertAdjacentHTML('beforeend', freq_dom);

            container.querySelectorAll('.freq_opts span').forEach((opt) => {
              opt.addEventListener('click', () => {
                select.value = opt.dataset.value;
                container.querySelector('.freq_opts span.active').classList.remove('active');
                opt.classList.add('active');
              })
              opt.style.order = opt_arr.indexOf(parseInt(opt.dataset.freq));
            })
          }

          if(mutation.target.classList.contains('rc_widget__option--onetime')) {
            let default_opt = document.querySelector(`[data-option-${rc_default_opt}]`);
            if(default_opt && is_opt_selected == false) {
              setTimeout(() => {
                default_opt.querySelector('label.rc-radio__label').click();
              }, 200);
              is_opt_selected = true;
            };
          }
        }
      };
      const observer = new MutationObserver(callback);
      observer.observe(targetNode, config);
      // observer.disconnect();
    }
  }


  const initCartDrawer = () => {

    let cartDrawer = document.querySelector('cart-drawer');

    document.querySelectorAll('[data-cart-drawer-open]').forEach((openCart) => {
      openCart.addEventListener('click', (e) => {
        e.preventDefault();
        cartDrawer.classList.add('open');
        // updateCartDrawer();
      })
    })
    document.querySelectorAll('[data-cart-drawer-close]').forEach((closeCart) => {
      closeCart.addEventListener('click', (e) => {
        e.preventDefault();
        cartDrawer.classList.remove('open');
      })
    })

    document.addEventListener('click', async (e) => {
      if(e.target.classList.contains('cart-item-remove')) {
        let line = e.target.closest('[data-cart-item]').dataset.lineId;
        await updateCartItem(line, 0);
        // await handleGwp(true);
        await updateCartDrawer(true);
        document.dispatchEvent(new CustomEvent("gwpEvent"));
      }
    })

    document.addEventListener('click', async (e) => {
      if(e.target.classList.contains('cart-drawer-upsell-add')) {
        let id = e.target.closest('[data-upsell-item]').dataset.id;
        let selling_plan = e.target.closest('[data-upsell-item]').dataset.sellingPlanId || '';
        await addCartItem(id, selling_plan, 1);
        // await handleGwp(true);
        await updateCartDrawer(true);
        document.dispatchEvent(new CustomEvent("gwpEvent"));
      }
    })

    document.addEventListener('change', async (e) => {
      if(e.target.classList.contains('cart-drawer-item--qty-select')) {
        let line = e.target.closest('[data-cart-item]').dataset.lineId;
        let qty = e.target.value;
        await updateCartItem(line, qty);
        // await handleGwp(true);
        await updateCartDrawer(true);
        document.dispatchEvent(new CustomEvent("gwpEvent"));
      }
    })

    // $(document).on('click', '.cart-drawer-upsell-title', () => {
    //   $('.cart-drawer-upsell').toggleClass('collapsed');
    //   $(".cart-drawer-upsell-products").slideToggle();
    // })

  }


  const initUpsellPopup = () => {
    let upsellPopup = document.querySelector('upsell-popup');
    if(!upsellPopup) return;
    document.querySelectorAll('[data-upsell-popup-close]').forEach((popupClose) => {
      popupClose.addEventListener('click', async () => {
        upsellPopup.classList.remove('open');
        updateCartDrawer(true);
        document.dispatchEvent(new CustomEvent("gwpEvent"));
      })
    })

    document.querySelectorAll('.upsell-popup-item-add').forEach((itemAdd) => {
      itemAdd.addEventListener('click', async () => {
        let upsellItem = itemAdd.closest('[data-upsell-item]');
        let id = upsellItem.dataset.id;
        let selling_plan = upsellItem.dataset.sellingPlanId || '';
        upsellPopup.classList.remove('open');
        await addCartItem(id, selling_plan, 1);
        await updateCartDrawer(true);
        // await handleGwp(true, true);
        document.dispatchEvent(new CustomEvent("gwpEvent"));
      })
    })

  }


  const initRechargeEvent = () => {
    document.querySelectorAll('.product-rc-button').forEach((rcButton) => {
      rcButton.addEventListener('click', () => {
        document.querySelector('.product-rc-box.active').classList.remove('active');
        rcButton.closest('.product-rc-box').classList.add('active');

        let price = formatMoney(parseFloat(rcButton.querySelector('.product-rc-price').dataset.price));
        let btnPrice = document.querySelector('.product__add-to-cart [data-price]');
        if(btnPrice) {
          btnPrice.innerText = price;
        }
      })
    })

    document.querySelectorAll('.product-rc-plan-button').forEach((rcPlanButton) => {
      rcPlanButton.addEventListener('click', () => {
        document.querySelector('.product-rc-plan-button.active').classList.remove('active');
        rcPlanButton.classList.add('active');
      })
    })
  }


  // Events

  const initEvents = () => {

    let pdp_view_ingredient = document.querySelector('.view-ingredients');
    let pdp_ingredient_image = document.querySelector('.product-ingredient-image-wrapper');
    let pdp_add_to_cart_btns = document.querySelectorAll('.product__add-to-cart, .sticky-button-just');
    if(pdp_view_ingredient) {
      pdp_view_ingredient.addEventListener('click', (e) => {
        e.preventDefault();
        pdp_ingredient_image.classList.toggle('active');
      })
    }
    if(pdp_add_to_cart_btns.length > 0) {
      pdp_add_to_cart_btns.forEach( (atc_btn) => {
        atc_btn.addEventListener('click', (e) => {
          // dataLayer.push({'event': 'add_to_cart'});
        })
      });
    }
  }

  return {
    initEvents: initEvents,
    // initStickyHorizontalSlider: initStickyHorizontalSlider,
    initTimeline: initTimeline,
    initTestimonial: initTestimonial,
    ingredientsSlider: ingredientsSlider,
    initRechargeInfoToggle: initRechargeInfoToggle,
    // initRechargeFrequency: initRechargeFrequency,
    // initNAD: initNAD
    initCartDrawer: initCartDrawer,
    initUpsellPopup: initUpsellPopup,
    initRechargeEvent: initRechargeEvent
  }

}();

// DOMContentLoaded
document.addEventListener("DOMContentLoaded", (event) => {

  document.addEventListener("triggerGwpProps", async (event) => {
    console.log('triggerGwpProps event caught');
    const selector = document.querySelector("[data-replo-variant-id]");
    const variant_id = selector ? selector.getAttribute("data-replo-variant-id") : null;

    if (variant_id) {
      const response = await fetch("/cart.js");
      const cart = await response.json();
      const cartItem = cart.items.find((item) => item.id === parseInt(variant_id));
      if (cartItem) {
        const updateResponse = await fetch(`/cart/change.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: cartItem.key,
            properties: {
              _allow_gift_with_purchased: "yes",
            },
          }),
        });
        const updatedCart = await updateResponse.json();
        console.log("Cart item updated with _allow_gift_with_purchased property:", updatedCart);
        // Trigger gwpEvent
        document.dispatchEvent(new CustomEvent("gwpEvent"));
      }
    }
  });

});

document.addEventListener("refreshCard", async (event) => {
  await updateCartDrawer(true);
});

document.addEventListener("DOMContentLoaded", (event) => {
  // ThemeFunc.initStickyHorizontalSlider();
  ThemeFunc.initEvents();
  ThemeFunc.initTimeline();
  ThemeFunc.initTestimonial();
  ThemeFunc.ingredientsSlider();
  ThemeFunc.initRechargeInfoToggle();
  // ThemeFunc.initRechargeFrequency();
  ThemeFunc.initCartDrawer();
  ThemeFunc.initUpsellPopup();
  ThemeFunc.initRechargeEvent();
  // ThemeFunc.initNAD();
})

document.addEventListener('scroll', () => {
  // ThemeFunc.initStickyHorizontalSlider();
  // ThemeFunc.initTimeline();
  // ThemeFunc.initNAD();
})